/**
 * /dashboard/customize — Widget-Auswahl als eigene Seite (Stream D, R4)
 *
 * Dateiname mit Trailing-Underscore (`dashboard_`): TanStack-Konvention fuer
 * "gleiche URL-Verschachtelung, KEINE Layout-Verschachtelung". Noetig, weil
 * /_auth/dashboard bereits eine eigene Komponente rendert (dashboard.lazy)
 * und keinen <Outlet/> hat — ein echtes Kind wuerde nie gerendert.
 */
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { DashboardCustomizePage } from '../features/dashboard/DashboardCustomizePage'
import './dashboard.css'

// R5 / Stream TD: Das Layout ist NICHT tag-spezifisch (v1 hat genau ein Layout
// pro User, users.dashboard_layout). Der `tag`-Param wird hier nur
// durchgereicht, damit "Zurueck zum Dashboard" wieder im Tag-Scope landet.
const customizeSearchSchema = z.object({
  // FE-ROB-06: ?tag=abc darf nicht die ganze Seite crashen
  tag: z.coerce.number().int().positive().optional().catch(undefined),
})

export const Route = createFileRoute('/_auth/dashboard_/customize')({
  validateSearch: customizeSearchSchema,
  component: DashboardCustomizePage,
})
